import { render, staticRenderFns } from "./PracticeViewContent.vue?vue&type=template&id=510989ec&scoped=true&"
import script from "./PracticeViewContent.vue?vue&type=script&lang=js&"
export * from "./PracticeViewContent.vue?vue&type=script&lang=js&"
import style0 from "./PracticeViewContent.vue?vue&type=style&index=0&id=510989ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510989ec",
  null
  
)

export default component.exports